import { CSSProperties, useEffect, useState } from 'react';

type CustomCSSProperty = CSSProperties & { [key: string]: string | number };

type PresenceState = 'open' | 'closed';
interface UsePresenceResult {
    shouldRender: boolean;
    delay: number;
    presenceProps: {
        'data-state': PresenceState;
        style: CustomCSSProperty;
    };
}

export const usePresence = (
    isVisible: boolean,
    delay: number = 250,
): UsePresenceResult => {
    const [isExiting, setIsExiting] = useState(false);
    const [shouldRender, setShouldRender] = useState(isVisible);

    useEffect(() => {
        if (isVisible) {
            setShouldRender(true);
            setIsExiting(false);
        } else if (shouldRender) {
            setIsExiting(true);
            const timer = setTimeout(() => {
                setShouldRender(false);
                setIsExiting(false);
            }, delay);
            return () => clearTimeout(timer);
        }
    }, [isVisible, delay, shouldRender]);

    return {
        shouldRender,
        delay,

        presenceProps: {
            'data-state': isExiting ? 'closed' : 'open',
            style: {
                '--presence-delay': `${delay}ms`,
            },
        },
    };
};
